// extracted by mini-css-extract-plugin
export default {"container":"FilterBanner_container__MM5MN","btnClose":"FilterBanner_btnClose__PnMmc"};